import validator from 'validator';

const validatePurchaseEmail = (data) => {
    let errorValue = {};

    const { email} = data;
    if (validator.isEmpty(email)) {
        errorValue.email = '이메일이 필요합니다';
    }else if (!validator.isEmail(email)) {
        errorValue.email = '잘못된 이메일 주소입니다.';
    }
    return {
        isInvalid: Object.keys(errorValue).length > 0,
        errorValue: errorValue,
    };
};

export default validatePurchaseEmail;